<template>
  <div :class="comboClass">
    <div class="d-felx" :class="topTitleClass">
      <h6 v-if="topTitle != ''" class="d-inline">{{ topTitle }}</h6>
      <span v-if="required" class="text-danger mx-1">*</span>
    </div>
    <select
      ref="comboSelect"
      id="comboSelect"
      :disabled="disabled"
      class="form-select text-end pointer mb-1"
      :class="comboClassComputed"
      @change="selectItemChanged($event)"
    >
      <option class="d-none">
        <span style="color: red !important">{{ warningSelectRow }}</span>
      </option>
      <option
        :value="item[itemKey]"
        v-for="item in comboList"
        :key="item[itemKey]"
        :selected="item[itemKey] == selectedItem"
      >
        {{ item[itemValue] }}
      </option>
    </select>
    <div v-if="!validated" class="errorSize" :class="errorClass">
      <span>{{ errorText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { validated: true };
  },
  beforeMount() {},
  props: {
    errorText: {
      type: String,
      required: false,
      default: '',
    },
    errorClass: {
      type: String,
      required: false,
      default: 'text-danger',
    },
    topTitleClass: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    topTitle: {
      type: String,
      required: false,
      default: '',
    },
    paerntID: {
      type: [Number, String],
      required: false,
    },
    selectedItem: {
      type: [Number, String],
      required: false,
      default: -1,
    },
    warningSelectRow: {
      type: String,
      required: false,
      default: 'لطفا یک ردیف را انتخاب نمایید',
    },
    comboList: {
      type: Array,
      required: true,
    },
    itemKey: {
      type: String,
      required: true,
    },
    itemValue: {
      type: String,
      required: true,
    },
    comboTitle: {
      type: String,
      default: '',
      required: false,
    },
    comboSize: {
      type: String,
      default: '',
      required: false,
    },
    comboClass: {
      type: String,
      required: false,
      default: '',
    },
    selectAndOptionsClass: {
      type: String,
      required: false,
      default: '',
    },
    hasParent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    comboClassComputed() {
      return `${
        this.comboSize == 'sm'
          ? 'form-select-sm'
          : this.comboSize == 'lg'
          ? 'form-select-lg'
          : ''
      } ${!this.validated ? 'isNotValid' : ''} ${this.selectAndOptionsClass}`;
    },
  },
  methods: {
    selectItemChanged(e) {
      if (this.hasParent)
        this.$emit('parentInvoker', e.target.value, this.$props.paerntID);
      else {
        this.$emit('comboOnChanged', e.target.value);
        this.$emit('update:selectedItem', e.target.value);
      }
      this.validated = true;
    },
    setFocus() {
      this.$refs.comboSelect.focus();
    },
    showErrorMessage() {
      this.validated = false;
    },
    hideErrorMessage() {
      this.validated = true;
    },
  },
};
</script>
<style scoped>
.isNotValid {
  border-color: #f64e60;
}
.errorSize {
  font-size: 0.75em;
}
</style>
